import { render, staticRenderFns } from "./PartitionManagement.vue?vue&type=template&id=19c32ae4"
import script from "./PartitionManagement.vue?vue&type=script&lang=js"
export * from "./PartitionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports